import { render } from "./titleTemplate.vue?vue&type=template&id=594fdc3a"
import script from "./titleTemplate.vue?vue&type=script&lang=js"
export * from "./titleTemplate.vue?vue&type=script&lang=js"

import "./titleTemplate.vue?vue&type=style&index=0&id=594fdc3a&lang=css"

import exportComponent from "C:\\Project\\VuePro\\classCloud\\kclass-index-mtzls\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__